// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1__e58c1d300b2eff5b910e","cls2":"AccountMenu-cls2__a195bd2d8951d8097f4f AccountMenu-cls1__e58c1d300b2eff5b910e"};